
export  const table_headers = {"publication_title":"Yayın Adı", "date":"Tarihi", "authors":"Yazarlar", "text":"Girdi Oluşturacak Özet Bilgi",
                         "criterion": "Başarı Ölçütü", "target": "Hedeflenen Değer", 
                         "technique": "Teknik / Teknolojinin\nAdı/Tanımı", "develop": "Kullanılacak / Geliştirilecek", "justification": "Gerekçe", "wp": "İş Paketi", 
                         "risk_definition": "Risk", "preventive_measures": "Riskin Gerçekleşmemesi İçin Alınan Önlemler", 
                         "probability": "Olasılık", "impact": "Etki", "plan_b": "B Planı"};


export  const wp_table_headers = {"outcome.name":"Çıktı","outcome.due_date":"Beklenen Tarih", "outcome.used_in": "Kullanılacak İP'ler",
                                  "exp.name": "Deney / Test Adı", "exp.reason": "Yapılma Nedeni"};